import { render, staticRenderFns } from "./LaCahute.vue?vue&type=template&id=46acbe62&"
import script from "./LaCahute.vue?vue&type=script&lang=js&"
export * from "./LaCahute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports